import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu } from "lucide-react";
import logoAcelerai from "@/assets/logo-acelerai.png";

const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const isLandingPage = location.pathname === "/";

  const navLinks = [
    { section: "beneficios", label: "Benefícios" },
    { section: "como-funciona", label: "Como Funciona" },
    { section: "servicos", label: "Serviços" },
    { section: "planos", label: "Planos" },
  ];

  const getHref = (section: string) => (isLandingPage ? `#${section}` : `/#${section}`);

  const handleLogoClick = (e: React.MouseEvent) => {
    if (isLandingPage) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/60 backdrop-blur-xl border-b border-border/40">
      <div className="container mx-auto px-4 h-16 md:h-20 flex items-center justify-between">
        <Link
          to="/"
          onClick={handleLogoClick}
          className="flex items-center gap-2 cursor-pointer"
        >
          <img 
            src={logoAcelerai} 
            alt="Acelerai" 
            className="h-9 md:h-12 object-contain"
            width={160}
            height={48}
            decoding="async"
          />
        </Link>
        
        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <a 
              key={link.section}
              href={getHref(link.section)} 
              className="text-sm text-muted-foreground hover:text-foreground transition-colors font-medium"
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Desktop buttons */}
        <div className="hidden md:flex items-center gap-3">
          <Link to="/login">
            <Button variant="ghost" size="sm" className="text-muted-foreground hover:text-foreground">
              Entrar
            </Button>
          </Link>
          <a href={getHref("planos")}>
            <Button size="sm" className="bg-primary hover:bg-primary/90 rounded-lg font-medium">
              Seja Parceiro
            </Button>
          </a>
        </div>

        {/* Mobile menu */}
        <div className="flex md:hidden items-center gap-2">
          <Link to="/login">
            <Button variant="ghost" size="sm" className="text-muted-foreground hover:text-foreground text-sm">
              Entrar
            </Button>
          </Link>
          <Sheet open={open} onOpenChange={setOpen}>
            <SheetTrigger asChild>
              <Button variant="ghost" size="icon" className="hover:bg-muted">
                <Menu className="w-5 h-5" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-[280px]">
              <div className="flex flex-col gap-6 mt-8">
                <nav className="flex flex-col gap-4">
                  {navLinks.map((link) => (
                    <a 
                      key={link.section}
                      href={getHref(link.section)}
                      onClick={() => setOpen(false)}
                      className="text-base text-muted-foreground hover:text-foreground transition-colors font-medium"
                    >
                      {link.label}
                    </a>
                  ))}
                </nav>
                <div className="flex flex-col gap-3 pt-4 border-t border-border">
                  <Link to="/login" onClick={() => setOpen(false)}>
                    <Button variant="outline" className="w-full">
                      Entrar
                    </Button>
                  </Link>
                  <a href={getHref("planos")} onClick={() => setOpen(false)}>
                    <Button className="w-full bg-primary hover:bg-primary/90">
                      Seja Parceiro
                    </Button>
                  </a>
                </div>
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </header>
  );
};

export default Header;
